/**
 * Hook tải thống kê dashboard admin khi mount trang.
 */
import { useEffect, useState } from 'react';
import { dashboardApi } from '../api/dashboardApi';

/**
 * @returns {{ dashboardStats: Object|null, isLoadingDashboard: boolean }}
 */
export const useAdminDashboard = () => {
  const [dashboardStats, setDashboardStats] = useState(null);
  const [isLoadingDashboard, setIsLoadingDashboard] = useState(true);

  useEffect(() => {
    let isMounted = true;

    dashboardApi
      .getDashboard()
      .then((response) => {
        if (isMounted) {
          setDashboardStats(response.data.data);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoadingDashboard(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    dashboardStats,
    isLoadingDashboard,
  };
};
